import { useHomeGoalStore } from "../../stores/homeGoalStore";
import type { PropertySearching } from "../../interfaces/propertySearching";
import { PropertyTypeSelector } from "../PropertySearchingView/propertyTypeSelector";
import { useUserProfileStore } from "../../stores/profileStore";
import { use, useEffect } from "react";

const propertySearchingData: PropertySearching[] = [
	{ value: "Detached" },
	{ value: "Semi-Detached" },
	{ value: "Townhouse" },
	{ value: "Condo Townhouse" },
	{ value: "Condo" },
	{ value: "Apartment" },
];

const frontendToBackend: Record<string, string> = {
	Detached: "DETACHED",
	"Semi-Detached": "SEMI_DETACHED",
	Townhouse: "TOWNHOUSE",
	"Condo Townhouse": "CONDO_TOWNHOUSE",
	Condo: "CONDO",
	Apartment: "APARTMENT",
};
const backendToFrontend = Object.fromEntries(
	Object.entries(frontendToBackend).map(([k, v]) => [v, k]),
) as Record<string, string>;

export const PropertyTypeSelectionView = () => {
	const { propertyTypes, setPropertyTypes } = useHomeGoalStore();
	const { userProfile } = useUserProfileStore();

	const frontendSelected = propertyTypes.map(
		(code) => backendToFrontend[code] || code,
	);

	useEffect(() => {
		if (userProfile?.homeGoal?.propertyTypes) {
			const propertyTypes = userProfile.homeGoal.propertyTypes;
			setPropertyTypes(propertyTypes);
		}
	}, [userProfile, setPropertyTypes]);

	const handleToggle = (frontend: string) => {
		const backend = frontendToBackend[frontend] || frontend;
		setPropertyTypes((prev) =>
			prev.includes(backend)
				? prev.filter((b) => b !== backend)
				: [...prev, backend],
		);
	};

	return (
		<div className="h-full px-4 pt-2 space-y-8">
			<div className="text-2xl font-bold">
				What type of property are you searching for?
			</div>
			<PropertyTypeSelector
				display="grid"
				gap="14px"
				customClassName="min-w-[145px] w-full"
				parentClassName="grid-cols-2"
				options={propertySearchingData}
				selectedValue={frontendSelected}
				onChange={handleToggle}
				width="fit"
				height="50px"
			/>
		</div>
	);
};
